import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=22e849c8&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports